import { nullable, string, struct } from 'io-ts/Decoder';

export const Request = struct({
	label: nullable(string),
});
